import React, { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Live countdown shown on the beta gate — renders nothing until admin sets a date
const GateCountdown = () => {
  const [cfg, setCfg] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/gate/countdown`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.enabled && d?.target_utc) setCfg(d); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!cfg) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [cfg]);

  if (!cfg) return null;

  const diff = new Date(cfg.target_utc).getTime() - now;
  const opened = diff <= 0;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  const block = (val, label) => (
    <div key={label} style={{ textAlign: 'center', minWidth: '58px' }}>
      <div style={{
        fontSize: '28px', fontWeight: 800, color: '#fff', lineHeight: 1,
        padding: '10px 8px', borderRadius: '10px',
        background: 'rgba(0,0,0,0.45)',
        border: '1px solid rgba(0,255,255,0.35)',
        boxShadow: '0 0 18px rgba(0,255,255,0.15), inset 0 0 12px rgba(255,0,255,0.08)',
        fontVariantNumeric: 'tabular-nums',
      }}>
        {String(val).padStart(2, '0')}
      </div>
      <div style={{ fontSize: '9px', letterSpacing: '0.18em', color: '#7dd3fc', marginTop: '5px', textTransform: 'uppercase' }}>{label}</div>
    </div>
  );

  return (
    <div data-testid="gate-countdown" style={{ margin: '18px auto 4px', maxWidth: '460px' }}>
      <div style={{
        fontSize: '12px', fontWeight: 800, letterSpacing: '0.28em', textAlign: 'center',
        marginBottom: '10px', textTransform: 'uppercase',
        background: 'linear-gradient(90deg, #00ffff, #ff00ff)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
      }}>
        ⚡ {cfg.title} ⚡
      </div>
      {opened ? (
        <div style={{
          textAlign: 'center', fontSize: '16px', fontWeight: 800, color: '#00ff88',
          padding: '10px', borderRadius: '10px',
          background: 'rgba(0,255,136,0.08)', border: '1px solid rgba(0,255,136,0.4)',
        }} data-testid="gate-countdown-live">
          🎉 IT'S TIME — DOORS ARE OPENING!
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }} data-testid="gate-countdown-timer">
          {block(d, 'Days')}
          {block(h, 'Hours')}
          {block(m, 'Min')}
          {block(s, 'Sec')}
        </div>
      )}
      {!opened && cfg.event_date && (
        <div style={{ textAlign: 'center', fontSize: '10px', color: '#94a3b8', marginTop: '8px', letterSpacing: '0.08em' }}>
          {new Date(`${cfg.event_date}T12:00:00`).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })} · {cfg.event_time} {cfg.tz}
        </div>
      )}
    </div>
  );
};

export default GateCountdown;
